import React from 'react'
import './../styles/index.css'


const Info = (props) => {
  let className = ''
  if (props.orientation === 'horizontal') {
    className = 'info-horizontal'
  }
  else if (props.orientation === 'vertical') {
    className = 'info-vertical'
  }
  return (
    <div className={className} {...props}>{props.children}</div>
  )
};

export default Info


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/WebCarousel/components/Info.js